import { render, staticRenderFns } from "./orderList.vue?vue&type=template&id=10fb6f22&scoped=true&"
import script from "./orderList.vue?vue&type=script&lang=js&"
export * from "./orderList.vue?vue&type=script&lang=js&"
import style0 from "./orderList.vue?vue&type=style&index=0&id=10fb6f22&lang=scss&scoped=true&"
import style1 from "./orderList.vue?vue&type=style&index=1&lang=css&"
import style2 from "./orderList.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fb6f22",
  null
  
)

component.options.__file = "orderList.vue"
export default component.exports